import { render, staticRenderFns } from "./CompanyCompanyHoliday.vue?vue&type=template&id=72eb289b"
import script from "./CompanyCompanyHoliday.vue?vue&type=script&lang=js"
export * from "./CompanyCompanyHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports